// src/components/help/HelpLink.jsx
// Drop-in (?) icon that opens the HelpSlideOver with a specific article.
// Usage: <HelpLink article="billing/invoices" />

import { HelpCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useHelpPanel } from '@/contexts/HelpContext';
import { useHelp } from '@/hooks/useHelp';

export function HelpLink({ article, label, className, iconSize = 'h-4 w-4' }) {
  const { openArticle } = useHelpPanel();
  const { getArticle } = useHelp();

  // article is "category/slug" format
  const [category, slug] = (article || '').split('/');
  const articleData = getArticle(category, slug);

  // Don't render if article doesn't exist or isn't visible
  if (!articleData) return null;

  const tooltip = label || articleData.title;

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        openArticle(articleData);
      }}
      title={tooltip}
      className={cn(
        'inline-flex items-center text-gray-400 hover:text-primary transition-colors',
        className
      )}
    >
      <HelpCircle className={iconSize} />
    </button>
  );
}
